export const dnldScheduledCamp = (builder) => ({
    dnldScheduledCamp: builder.mutation({
        query: ({  search, status, campaignType, loggedin_user_id, user_type_id, startDate, endDate }) => {
            return {
                url: '/downloadScheduledCampaignLogs',
                method: 'GET',
                params: {  search, status, campaignType, loggedin_user_id, user_type_id, startDate, endDate  },
                headers: {
                    'Content-Type':  'text/csv', 
                },
                responseHandler: (response) => response.blob(),
            };
        },
    }),
});